import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import useData, { SortOrders } from "@cervello/use-data";
import { WorkRequest } from "../../../definitions/types/workRequests";
import debounce from "lodash.debounce";
import * as api from "../../../api/workorderPrintPageApi";
import { WorkQueue } from "modules/IotPaaS/Maintenance/definitions/types/workOrders";
import { WorkOrder } from "modules/IotPaaS/Admin/definitions/types/spareParts";


function UseworkorderPrintPage() {
  const { projectId, taskId } = useParams<{ projectId: string, taskId: string }>();
  const [reportingData, setReportingData] = useState<WorkOrder | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const getReportByWorkOrderId = useCallback(async () => {

    try {
      const res = await api.getWorkOrderReportById(projectId, taskId);
      const { data }: { data: WorkOrder } = res;
      setReportingData(data);

    } catch (err: any) {
      console.error("Failed to fetch work order report:", err);
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [projectId, taskId]);

  useEffect(() => {
    getReportByWorkOrderId();
  }, []);


  return {
    reportingData
  };
}

export default UseworkorderPrintPage;
